/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useReducer, useMemo } from "react";
import oapi from "config/openapi";
import api from "config/api";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Cookies from "js-cookie";

// import { useNavigate } from "react-router-dom";


// Material Dashboard 2 React main context
const MaterialUI = createContext();

// Setting custom name for the context which is visible on react dev tools
MaterialUI.displayName = "MaterialUIContext";

// Material Dashboard 2 React reducer
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "TRANSPARENT_SIDENAV": {
      return { ...state, transparentSidenav: action.value };
    }
    case "WHITE_SIDENAV": {
      return { ...state, whiteSidenav: action.value };
    }
    case "SIDENAV_COLOR": {
      return { ...state, sidenavColor: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "OPEN_CONFIGURATOR": {
      return { ...state, openConfigurator: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "DARKMODE": {
      return { ...state, darkMode: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// Material Dashboard 2 React context provider
function MaterialUIControllerProvider({ children }) {
  const initialState = {
    miniSidenav: false,
    transparentSidenav: false,
    whiteSidenav: false,
    sidenavColor: "info",
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "ltr",
    layout: "dashboard",
    darkMode: false,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <MaterialUI.Provider value={value}>{children}</MaterialUI.Provider>;
}


const SignIn = async (userData) => {
  try {
    const response = await oapi.post('/auth/login', userData); // Base URL is already set in api.js
    // localStorage.setItem('token', response.data.token);
    Cookies.set("token", response.data.token, { secure: true, sameSite: "strict" });
    Cookies.set("user", JSON.stringify(response.data.user), { secure: true, sameSite: "strict" });
    return { response, status: true };
    // Set the user state if you have a state management function
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error('Server responded with an error:', error.response.data.message);
      alert(`Login failed: ${error.response.data.message}`);
      return error.response
    } else if (error.request) {
      // The request was made, but no response was received
      console.error('No response received from the server:', error.request);
      alert('Login failed: No response from the server. Please try again.');
      return error.request
    }
    else {
      // Other errors, e.g., setting up the request
      console.error('Error in setting up the login request:', error.message);
      alert('Login failed: An error occurred. Please try again.');
      return  error.message
    }
  }
}

const signUp = async (userData) => {
  try {
    const response = await oapi.post("/auth/register", userData); // Base URL is already set in api.js
    // localStorage.setItem("token", response.data.token);
    Cookies.set("token", response.data.token, { secure: true, sameSite: "strict" });

  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Login failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert("Login failed: No response from the server. Please try again.");
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Login failed: An error occurred. Please try again.");
    }
  }
}
function logout() {
  Cookies.remove("token");
  Cookies.remove("user");
  setTimeout(() => {
    window.location.href = '/authentication/sign-in'; // Redirect after 3 seconds
  }, 3000); // Timer in milliseconds
}
const Get_Chat_detail = async (Id) => {
  try {
    const response = await api.get(`/chat/${Id}`); // Base URL is already set in api.js
    let chatHistory = response.data.chat;
    return chatHistory;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Chats Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Chats Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Chats Fetch failed: An error occurred. Please try again.");
    }
  }
};
const Get_Chats = async () => {
  try {
    const response = await api.get("/chats"); // Base URL is already set in api.js
    let chats = response.data.chats;
    return chats;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Chats Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Chats Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Chats Fetch failed: An error occurred. Please try again.");
    }
  }
};
const Send_Message = async (messageBody) => {
  
  try {
    const response = await api.post(`/message`, messageBody); // Base URL is already set in api.js
    let chatHistory = response.data.chat;
    return chatHistory;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Chats Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Chats Fetch failed: No response from the server. Please try again."
      );
    }
    else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Chats Fetch failed: An error occurred. Please try again.");
    }
  }
};
const saveOrganizations = async (body) => {
  try {
    const response = await api.post(`/organizations`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Organization Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Organization Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Organization Fetch failed: An error occurred. Please try again.");
    }
  }
};
const deleteOrganization = async (body) => {
  console.log(body);
  try {
    const response = await api.delete(`/organizations`, { data: body }); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Organization Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Organization Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Organization Fetch failed: An error occurred. Please try again.");
    }
  }
};
const getOrganizations = async (body) => {
  try {
    const response = await api.get(`/organizations`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Organization Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Organization Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Organization Fetch failed: An error occurred. Please try again.");
    }
  }
};
const getkeys = async (body) => {
  try {
    const response = await api.get(`/keys`); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Organization Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Organization Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Organization Fetch failed: An error occurred. Please try again.");
    }
  }
};
const savekey = async (body) => {
  try {
    const response = await api.post(`/key`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Key Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Key Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Key Fetch failed: An error occurred. Please try again.");
    }
  }
};
const deleteKey = async (body) => {
  console.log(body);
  try {
    const response = await api.delete(`/key`, { data: body }); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Key Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Key Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Key Fetch failed: An error occurred. Please try again.");
    }
  }
};
const getUsers = async (body) => {
  try {
    const response = await api.get(`/users`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Organization Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Organization Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Organization Fetch failed: An error occurred. Please try again.");
    }
  }
};
const saveUser = async (body) => {
  try {
    const response = await api.post(`/user`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`User Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "User Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("User Fetch failed: An error occurred. Please try again.");
    }
  }
};
const updateUser = async (body) => {
  try {
    const response = await api.put(`/user`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`User Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "User Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("User Fetch failed: An error occurred. Please try again.");
    }
  }
};
const deleteUser = async (body) => {
  try {
    const response = await api.post(`/user`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`User Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "User Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("User Fetch failed: An error occurred. Please try again.");
    }
  }
};



const getRoles = async (body) => {
  try {
    const response = await api.get(`/roles`, body); // Base URL is already set in api.js
    return response;
  } catch (error) {
    // Check if there is a response from the server
    if (error.response) {
      // The request was made, and the server responded with a status code that falls outside of 2xx range
      console.error(
        "Server responded with an error:",
        error.response.data.message
      );
      alert(`Role Fetch failed: ${error.response.data.message}`);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error("No response received from the server:", error.request);
      alert(
        "Role Fetch failed: No response from the server. Please try again."
      );
    } else {
      // Other errors, e.g., setting up the request
      console.error("Error in setting up the login request:", error.message);
      alert("Role Fetch failed: An error occurred. Please try again.");
    }
  }
};







// Material Dashboard 2 React custom hook for using context
function useMaterialUIController() {
  const context = useContext(MaterialUI);

  if (!context) {
    throw new Error(
      "useMaterialUIController should be used inside the MaterialUIControllerProvider."
    );
  }

  return context;
}
// Typechecking props for the MaterialUIControllerProvider
MaterialUIControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
const setWhiteSidenav = (dispatch, value) => dispatch({ type: "WHITE_SIDENAV", value });
const setSidenavColor = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setOpenConfigurator = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setDarkMode = (dispatch, value) => dispatch({ type: "DARKMODE", value });

export {
  MaterialUIControllerProvider,
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setSidenavColor,
  setTransparentNavbar,
  setFixedNavbar,
  setOpenConfigurator,
  setDirection,
  setLayout,
  setDarkMode,
  SignIn,
  Get_Chats,
  Get_Chat_detail,
  Send_Message,
  saveOrganizations,
  getOrganizations,
  deleteOrganization,
  getkeys,
  savekey,
  deleteKey,
  getUsers,
  saveUser,
  updateUser,
  deleteUser,
  getRoles,
  
  logout
};
